import { CommonHeader } from "../Common/CommonHeader";

export default function PublicationsCriteria() {
  return (
    <>
      <CommonHeader title="PUBLICATIONS CRITERIA" />
    </>
  );
}
